import React from "react";
import PageTitle from "../../../Utils/smsTitle";
import {SubHeader} from "../../../../Containers/SubHeader";
import MainSnackbar from "../../../Utils/Snackbar/SmsSnackbar";
import ObGynSidebar from "../../Utils/ObGynSidebar";
import ObGynPatientInfo from "../../Utils/ObGynPatientInfo";
import {bindActionCreators} from "redux";
import * as snackbarActions from "../../../../actions/snackbarActions";
import {connect} from "react-redux";
import {AdmissionForm} from "./AdmissionForm";

const  AdmitGynAndObsPatient= ({ actions, snackbars, match: { params } }) => {

    const user = JSON.parse(sessionStorage.getItem("user"));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const doctor_name = `${!_token.first_name ? "" : _token.first_name} ${!_token.last_name ? "" : _token.last_name}`;

    const {patient_number, visit_id, patient_type} = params;

    const closeSnackbar = () => {
        actions.snackbarActions.hideSnackbar();
    };


    const { openBar, type, message } = snackbars;


    return (
        <div className="journals">
            <PageTitle title="Admission"/>
            <SubHeader
                title="Doctor"
                subTitle="Admission"
                doctor_name={doctor_name}
            >
                <div className="header-icon-margin-right-zero"><img src="/images/antenatal-blue.png"
                                                                    className="icon-resize surgery-icon-tabs ante-natal-green"
                                                                    alt="Antenatal"/>
                </div>
            </SubHeader>
            <MainSnackbar
                open={openBar}
                handleCloseBar={closeSnackbar}
                variant={type}
                message={message}
            />

            <ObGynSidebar patient_number={patient_number} visit_id={visit_id} patient_type={patient_type}>
                <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} />
                <div style={{padding: '12px 16px'}}>
                    <AdmissionForm {...{actions,match:params}}/>
                </div>
            </ObGynSidebar>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        snackbars: state.snackbar,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            snackbarActions: bindActionCreators(snackbarActions, dispatch),
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdmitGynAndObsPatient);